import { createSlice } from "@reduxjs/toolkit";

// Toast messages keyed by action type (no imports needed — matched by string)
const TOAST_MAP = {
  // Representatives
  "subAccounts/create/fulfilled": { message: "Representative added",            severity: "success" },
  "subAccounts/create/rejected":  { message: "Failed to add representative",    severity: "error"   },
  "subAccounts/update/fulfilled": { message: "Representative updated",          severity: "success" },
  "subAccounts/update/rejected":  { message: "Failed to update representative", severity: "error"   },
  "subAccounts/toggle/fulfilled": { message: "Status updated",                  severity: "info"    },
  "subAccounts/delete/fulfilled": { message: "Representative removed",          severity: "success" },
  "subAccounts/delete/rejected":  { message: "Failed to remove representative", severity: "error"   },

  // Agents (Analytics tab)
  "analytics/addAgent/fulfilled":    { message: "Agent extension added",   severity: "success" },
  "analytics/addAgent/rejected":     { message: "Failed to add agent",     severity: "error"   },
  "analytics/toggleAgent/fulfilled": { message: "Agent status updated",    severity: "info"    },
  "analytics/deleteAgent/fulfilled": { message: "Agent extension removed", severity: "success" },

  // CRM tickets
  "crm/createTicket/fulfilled": { message: "Ticket created",     severity: "success" },
  "crm/createTicket/rejected":  { message: "Failed to create ticket", severity: "error" },
  "crm/addNote/fulfilled":      { message: "Note added",         severity: "success" },
  "crm/deleteNote/fulfilled":   { message: "Note deleted",       severity: "success" },
  "crm/addTask/fulfilled":      { message: "Task added",         severity: "success" },
  "crm/deleteTask/fulfilled":   { message: "Task deleted",       severity: "success" },
};

const toastSlice = createSlice({
  name: "toast",
  initialState: {
    open:     false,
    message:  "",
    severity: "success",
  },
  reducers: {
    showToast: (state, action) => {
      state.open     = true;
      state.message  = action.payload.message;
      state.severity = action.payload.severity || "success";
    },
    hideToast: (state) => {
      state.open = false;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      (action) => Boolean(TOAST_MAP[action.type]),
      (state, action) => {
        // 409 sole-agent flow is handled by the UI dialog — suppress the generic toast
        if (action.payload?._409) return;
        const cfg = TOAST_MAP[action.type];
        state.open     = true;
        // For rejected actions, prefer the thunk's payload message if it is a plain string
        const payloadStr = action.type.endsWith("/rejected") && typeof action.payload === "string"
          ? action.payload
          : null;
        state.message  = payloadStr || cfg.message;
        state.severity = cfg.severity;
      }
    );
  },
});

export const { showToast, hideToast } = toastSlice.actions;
export default toastSlice.reducer;
